// extracted by mini-css-extract-plugin
module.exports = {"input":"Landing_input__3zpyb","table":"Landing_table__3Xrsq"};